import {AxiosError} from "axios";
import {uploadReplacer} from "../../../4-upload-results/uploadReplacer.ts";

function describeRequest(e: AxiosError): string {
    const method = e.config?.method?.toUpperCase()
    const url = e.config?.url ?? ""
    const path = url.replace(/.*\/rest\/v1\//, "")
    if (!method && !path) return ""
    return ` (${[method, path].filter(Boolean).join(" ")})`
}

function describeBody(data: unknown): string {
    if (data === undefined || data === null || data === "") return "Unknown error - check the browser network tab for details"
    if (typeof data === "string") return data
    if (typeof data === "object" && !Array.isArray(data)) {
        const obj = data as Record<string, unknown>
        if (typeof obj.message === "string") return obj.message
        if (typeof obj.msg === "string") return obj.msg
    }
    try {
        return JSON.stringify(data, uploadReplacer)
    } catch {
        return "Unknown error - check the browser network tab for details"
    }
}

export function errorText(e: unknown): string {
    if (e instanceof AxiosError) {
        const requestSuffix = describeRequest(e)
        if (e.response) {
            const status = e.response.status.toString()
            const statusText = e.response.statusText || "?"
            const message = describeBody(e.response.data)
            return `[HTTP ${status} | ${statusText}]${requestSuffix} ${message}`
        }
        // No response — network error, CORS block, timeout, aborted, etc.
        const code = e.status ?? e.code ?? "ERR"
        const detail = e.message ? ` ${e.message}` : ""
        return `[Network ${code}]${requestSuffix} ${detail}`
    }
    if (e instanceof Error) {
        return e.message ?? "Unknown error"
    }
    return "Unknown error"
}